module.exports = "/_next/static/images/6ed53bd14cc10ca9a039959df526e5a7-logo-exame-investe.png";